<template>
  <v-layout
    class="overview-card" 
    wrap
  >
    <v-flex
      v-for="(item, i) in [1,2,3,4,5,6]"
      v-show="$apollo.loading"
      :key="i+100"
      md6
      xs12
    >
      <v-card>
        <v-skeleton-loader
          type="list-item-avatar"
          :tile="false"
          class="mx-auto"
          width="100%"
          height="110"
        />
      </v-card>
    </v-flex>
    <v-flex
      v-for="(item, i) in traderOverview"
      v-show="!$apollo.loading"
      :key="i"
      md6
      xs6
    >
      <v-card
        v-if="!$apollo.loading && traderOverview"
      >
        <span>{{ $t('globals.aum2') }} ({{ item.base_currency }})</span>
        <p
          class="text-primary balance"
        >
          {{ item.base_currency | renderSymbol }}
          {{ item.aum_total | formatMoney }}
        </p>
      </v-card>
    </v-flex>
    <v-flex
      v-for="(item, i) in traderOverview"
      v-show="!$apollo.loading"
      :key="i+5"
      md6
      xs6
    >
      <v-card
        v-if="!$apollo.loading && traderOverview"
      >
        <span>{{ $t('traderdashboard.pnlInvTotal') }} ({{ item.base_currency }})</span>
        <p
          :class="colorPnL(item.pnl_total)"
        >
          {{ item.base_currency | renderSymbol }}
          {{ item.pnl_total | formatMoney }}
        </p>
        <span>{{ $t('traderdashboard.pnlInvMonth') }} ({{ item.base_currency }})</span>
        <p
          :class="colorPnL(item.pnl_this_month)"
        >
          {{ item.base_currency | renderSymbol }}
          {{ item.pnl_this_month | formatMoney }}
        </p>
      </v-card>
    </v-flex>
    <v-flex
      v-for="(item, i) in traderOverview"
      v-show="!$apollo.loading"
      :key="i+10"
      md6
      xs6
    >
      <v-card
        v-if="!$apollo.loading && traderOverview"
      >
        <span>{{ $t('traderdashboard.earnedTotal') }} ({{ item.base_currency }})</span>
        <p>
          {{ item.base_currency | renderSymbol }}
          {{ item.commissions_total | formatMoney }}
        </p>
        <span>{{ $t('traderdashboard.earnedMonth') }} ({{ item.base_currency }})</span>
        <p>
          {{ item.base_currency | renderSymbol }}
          {{ item.commissions_this_month | formatMoney }}
        </p>
        <span>{{ $t('traderdashboard.paidTotal') }} ({{ item.base_currency }})</span>
        <p>
          {{ item.base_currency | renderSymbol }}
          {{ item.commissions_paid | formatMoney }}
        </p>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const TRADER_OVERVIEW_QUERY = require('@/graphql/queries/TraderOverview.gql');

export default {
  name: 'TraderOverview',
 
  data: () => ({
    tooltip: null,
    loading: false,
  }),
  methods: {
    
  },
  apollo: {
    traderOverview: {
      query: TRADER_OVERVIEW_QUERY
    }
  },
}
</script>



<style lang="scss" >
  .overview-card {
    .balance {
      font-weight: 700;
      font-size: 19px;
    }
    .v-btn__content {
      color: #fff;
      font-size: 15px;
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      padding-top: 5px;
      font-size: 18px;
      font-weight: 700;
    }
  }
</style>
